import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from './use-cases/session.service';
import { AppRoutes } from '@core/constants/app.routes';

/**
 * Servicio de inicialización de sesión.
 * Se encarga de:
 * - Configurar el auto-logout al cargar la app
 * - Escuchar eventos de sesión expirada
 * - Redirigir al login cuando sea necesario
 */
@Injectable({ providedIn: 'root' })
export class SessionInitService {
  private readonly sessionService = inject(SessionService);
  private readonly router = inject(Router);

  /**
   * Inicializa el servicio de sesión.
   * Debe ser llamado al inicio de la aplicación.
   */
  initialize(): void {
    // Verificar si hay una sesión existente y configurar auto-logout
    if (this.sessionService.isAuthenticated()) {
      // Verificar si la sesión ya expiró
      if (this.sessionService.isSessionExpired()) {
        this.sessionService.clearSession();
        void this.router.navigate(['/', AppRoutes.auth, AppRoutes.login]);
      }
    }

    // Escuchar evento de sesión expirada
    window.addEventListener('session-expired', () => {
      void this.router.navigate(['/', AppRoutes.auth, AppRoutes.login]);
    });
  }
}
